import revalidator from 'revalidator';

var ValidatorService =
/*#__PURE__*/
function () {
  function ValidatorService(_ref) {
    var data = _ref.data,
        validation = _ref.validation;
    this.data = data;
    this.validation = validation;
  }

  var _proto = ValidatorService.prototype;

  _proto.validate = function validate() {
    return revalidator.validate(this.data, {
      properties: this.validation
    });
  };

  return ValidatorService;
}();

export { ValidatorService };